import "@/App.css";
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import { Toaster } from "sonner";
import { AuthProvider } from "@/context/AuthContext";
import PublicLayout from "@/layouts/PublicLayout";
import { AdminLayout, DoctorLayout, NurseLayout } from "@/layouts/PortalLayouts";
import RequireRole from "@/components/portal/RequireRole";
import HomePage from "@/pages/HomePage";
import NotFoundPage from "@/pages/NotFoundPage";
import HowItWorks from "@/components/HowItWorks";
import ExamsSection from "@/components/ExamsSection";
import SpecialistsSection from "@/components/SpecialistsSection";
import ReportSection from "@/components/ReportSection";
import ElderlySection from "@/components/ElderlySection";
import PediatricsSection from "@/components/PediatricsSection";
import RSASection from "@/components/RSASection";
import OtherUsesSection from "@/components/OtherUsesSection";
import PricingSection from "@/components/PricingSection";
import FAQSection from "@/components/FAQSection";
import WorkWithUsSection from "@/components/WorkWithUsSection";
import ConversionBlock from "@/components/ConversionBlock";
import PrivacyPolicyPage from "@/pages/legal/PrivacyPolicyPage";
import TermsPage from "@/pages/legal/TermsPage";
import CookiePolicyPage from "@/pages/legal/CookiePolicyPage";
import ContactPage from "@/pages/ContactPage";
import LoginPage from "@/pages/portal/LoginPage";
import RegisterPage from "@/pages/portal/RegisterPage";
import ProfilePage from "@/pages/portal/ProfilePage";
import MyVisitsPage from "@/pages/portal/MyVisitsPage";
import AdminDashboard from "@/pages/admin/AdminDashboard";
import AdminVisits from "@/pages/admin/AdminVisits";
import AdminAgenda from "@/pages/admin/AdminAgenda";
import AdminCalendar from "@/pages/admin/AdminCalendar";
import AdminSpecialties from "@/pages/admin/AdminSpecialties";
import AdminWhatsApp from "@/pages/admin/AdminWhatsApp";
import StaffPage from "@/pages/admin/StaffPage";
import AdminContactRequests from "@/pages/admin/AdminContactRequests";
import DoctorCalendar from "@/pages/doctor/DoctorCalendar";

function PageShell({ children }) {
  return (
    <>
      <div className="pt-16 lg:pt-20">{children}</div>
      <ConversionBlock />
    </>
  );
}

function App() {
  return (
    <AuthProvider>
      <BrowserRouter>
        <Routes>
          {/* Sito pubblico */}
          <Route element={<PublicLayout />}>
            <Route path="/" element={<HomePage />} />
            <Route path="/come-funziona" element={<PageShell><HowItWorks /><ExamsSection /><ReportSection /></PageShell>} />
            <Route path="/medici" element={<PageShell><SpecialistsSection /></PageShell>} />
            <Route path="/specialisti" element={<Navigate to="/medici" replace />} />
            <Route path="/anziani" element={<PageShell><ElderlySection /></PageShell>} />
            <Route path="/pediatria" element={<PageShell><PediatricsSection /></PageShell>} />
            <Route path="/rsa" element={<PageShell><RSASection /></PageShell>} />
            <Route path="/altri-utilizzi" element={<PageShell><OtherUsesSection /></PageShell>} />
            <Route path="/prezzi" element={<PageShell><PricingSection /></PageShell>} />
            <Route path="/faq" element={<PageShell><FAQSection /></PageShell>} />
            <Route path="/lavora-con-noi" element={<div className="pt-16 lg:pt-20"><WorkWithUsSection /></div>} />
            <Route path="/contatti" element={<div className="pt-16 lg:pt-20"><ContactPage /></div>} />
            <Route path="/privacy-policy" element={<div className="pt-16 lg:pt-20"><PrivacyPolicyPage /></div>} />
            <Route path="/termini-e-condizioni" element={<div className="pt-16 lg:pt-20"><TermsPage /></div>} />
            <Route path="/cookie-policy" element={<div className="pt-16 lg:pt-20"><CookiePolicyPage /></div>} />
            <Route path="*" element={<NotFoundPage />} />
          </Route>

          {/* Area riservata: accesso e registrazione */}
          <Route path="/area-riservata" element={<LoginPage />} />
          <Route path="/area-riservata/registrazione-medico" element={<RegisterPage kind="doctor" />} />
          <Route path="/area-riservata/registrazione-infermiere" element={<RegisterPage kind="nurse" />} />

          {/* Amministrazione */}
          <Route path="/admin" element={<RequireRole roles={["admin"]}><AdminLayout /></RequireRole>}>
            <Route index element={<AdminDashboard />} />
            <Route path="agenda" element={<AdminAgenda />} />
            <Route path="visite" element={<AdminVisits />} />
            <Route path="calendario" element={<AdminCalendar />} />
            <Route path="medici" element={<StaffPage kind="doctors" />} />
            <Route path="infermieri" element={<StaffPage kind="nurses" />} />
            <Route path="candidature" element={<AdminContactRequests />} />
            <Route path="specialita" element={<AdminSpecialties />} />
            <Route path="whatsapp" element={<AdminWhatsApp />} />
          </Route>

          {/* Area medico */}
          <Route path="/medico" element={<RequireRole roles={["doctor"]}><DoctorLayout /></RequireRole>}>
            <Route index element={<DoctorCalendar />} />
            <Route path="visite" element={<MyVisitsPage />} />
            <Route path="profilo" element={<ProfilePage />} />
          </Route>

          {/* Area infermiere */}
          <Route path="/infermiere" element={<RequireRole roles={["nurse"]}><NurseLayout /></RequireRole>}>
            <Route index element={<MyVisitsPage />} />
            <Route path="profilo" element={<ProfilePage />} />
          </Route>
        </Routes>
        <Toaster
          position="top-center"
          theme="light"
          toastOptions={{
            style: {
              borderRadius: "9999px",
              background: "#1F152E",
              color: "#ffffff",
              border: "none",
              padding: "12px 20px",
            },
          }}
        />
      </BrowserRouter>
    </AuthProvider>
  );
}

export default App;
